'use strict';

exports.__esModule = true;
exports.ContactBoxTitle = exports.ContactBoxContainer = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 440px;\n  height: 245px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: ', ';\n  button {\n    width: 375px;\n    margin: ', ';\n  }\n  @media ', ' {\n    width: 280px;\n    height: 220px;\n    padding-top: ', ';\n    button {\n      width: 260px;\n    }\n  }\n'], ['\n  width: 440px;\n  height: 245px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: ', ';\n  button {\n    width: 375px;\n    margin: ', ';\n  }\n  @media ', ' {\n    width: 280px;\n    height: 220px;\n    padding-top: ', ';\n    button {\n      width: 260px;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 18px;\n  font-weight: ', ';\n  text-align: center;\n  margin-bottom: ', ';\n  @media ', ' {\n    margin-bottom: ', ';\n  }\n'], ['\n  color: ', ';\n  font-size: 18px;\n  font-weight: ', ';\n  text-align: center;\n  margin-bottom: ', ';\n  @media ', ' {\n    margin-bottom: ', ';\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _spacing = require('../../styles/spacing');

var _ui = require('../ui');

var _device = require('../../styles/device');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

// Primitiv-Migration (2026-06): navy-Vollflaechen-Karte erbt die Optik aus <Card>
// (variant navy = secondary-Flaeche; elevation none = ContactBox trug nie einen
// Schatten -> erhalten; radiusMd 10px = bewusster Token-Wechsel von 3px). Nur die
// festen Masse + das Flex-Layout + die Button-Breiten bleiben lokal.
var ContactBoxContainer = exports.ContactBoxContainer = (0, _styledComponents2.default)(_ui.Card).attrs({
  variant: 'navy',
  elevation: 'none'
})(_templateObject, (0, _spacing.space)(40), (0, _spacing.space)(5), _device.device.mobile, (0, _spacing.space)(30));

var ContactBoxTitle = exports.ContactBoxTitle = _styledComponents2.default.h3(_templateObject2, function (_ref) {
  var theme = _ref.theme;
  return theme.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeightBold;
}, (0, _spacing.space)(30), _device.device.mobile, (0, _spacing.space)(10));